import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function LebensgeschichteHoerbuch() {
  return (
    <MarketingPage
      eyebrow="Format · Hörbuch"
      h1={
        <>
          Die Lebensgeschichte als Hörbuch — in ihrer eigenen{" "}
          <Swoosh>Stimme</Swoosh>
        </>
      }
      lead={
        <>
          Ein Buch ist großartig. Aber ein Hörbuch in der{" "}
          <strong>eigenen Stimme</strong> der erzählenden Person ist etwas,
          das ein Buch nicht ersetzen kann. Vitanara bietet zusätzlich zum
          gedruckten Buch eine Audiofassung — vorgelesen aus dem fertigen
          Manuskript, mit derselben Stimme, die die Geschichten erzählt hat.
        </>
      }
      sections={[
        {
          h2: "Warum ein Hörbuch zusätzlich Sinn ergibt",
          body: (
            <p style={{ margin: 0 }}>
              Stimmen sind flüchtig. Ein Foto bewahrt das Gesicht, ein Brief
              die Worte — aber die Stimme verlierst du, wenn niemand sie
              aufnimmt. Wer einmal versucht hat, sich an die Stimme eines
              verstorbenen Großvaters zu erinnern und sie nicht mehr findet,
              weiß, warum dieses Hörbuch zählt.
            </p>
          ),
        },
        {
          h2: "Wie die Originalstimme bewahrt wird",
          body: (
            <p style={{ margin: 0 }}>
              Während der zwölf Wochen Telefongespräche entsteht ohnehin
              Material in der Originalstimme. Nach Abschluss des Manuskripts
              wird die Person eingeladen, ausgewählte Passagen frisch
              vorzulesen — als ruhige Studioaufnahme über Telefon, in zwei
              bis vier Sitzungen. Wer nicht mehr alles selbst einlesen
              möchte oder kann, lässt einzelne Kapitel von Konrad oder Ida
              vortragen, mit deutlich gekennzeichneter Stimme.
            </p>
          ),
        },
        {
          h2: "Format und Verteilung",
          body: (
            <p style={{ margin: 0 }}>
              Das Hörbuch wird im MP3- und MPEG-Format ausgeliefert, mit
              Kapitel-Marken, sodass einzelne Lebensabschnitte gezielt
              angesteuert werden können. Verteilt wird per privatem
              Download-Link an die Familie — nicht öffentlich, nicht auf
              Streaming-Plattformen.
            </p>
          ),
        },
        {
          h2: "Für wen das besonders schön ist",
          body: (
            <>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Für Enkel und Urenkel</strong>, die nach Jahrzehnten
                die Stimme der Großmutter oder des Großvaters wieder hören
                wollen.
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Für Menschen, die schlechter sehen</strong>, denen
                das Lesen schwerfällt.
              </p>
              <p style={{ margin: 0 }}>
                <strong>Für lange Autofahrten</strong> mit der Familie.
                Mehrere Vitanara-Kunden berichten, dass Sommerurlaube zum
                Hörbuch der Oma wurden — und dass die Kinder hinten
                ungewohnt still waren.
              </p>
            </>
          ),
        },
      ]}
      faqs={[
        {
          q: "Was, wenn die Stimme schwach wird?",
          a: "Wir nehmen sie auf, solange sie da ist. Wer nur noch wenige Sätze einsprechen kann, bekommt ein Hörbuch mit gemischten Stimmen – Mensch und Vitanara.",
        },
        {
          q: "Wie lang ist ein typisches Hörbuch?",
          a: "Zwischen sechs und sechzehn Stunden, abhängig vom Buchumfang.",
        },
        {
          q: "Kann ich das Hörbuch weitergeben?",
          a: "Ja, im engen Familienkreis. Eine kommerzielle Nutzung ist ausgeschlossen.",
        },
      ]}
      crossLinks={[
        {
          to: "/lebensgeschichte-als-podcast",
          label: "Lebensgeschichte als Podcast",
          blurb:
            "Folge für Folge — ein privater Familien-Podcast für mehrere Hörer.",
        },
        {
          to: "/wie-funktioniert-vitanara",
          label: "Wie funktioniert Vitanara?",
          blurb: "Vom Anruf bis zum leinengebundenen Buch in zwölf Wochen.",
        },
        {
          to: "/biografie-schreiben-lassen",
          label: "Biografie schreiben lassen",
          blurb:
            "Die schriftliche Lebensgeschichte als Kern jedes Vitanara-Projekts.",
        },
      ]}
    />
  );
}
